module.exports = __webpack_public_path__ + "img/first_sleep.decc40ca.svg";